var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login", style: { minHeight: _vm.height } },
    [
      _c(
        "el-card",
        {
          ref: "referenceCard",
          class: ["card", { "margin-none": _vm.isIframe }],
          attrs: { shadow: "never" }
        },
        [
          _c("div", { staticClass: "login-logo" }, [
            _c("a", { attrs: { href: "https://www.forchain.com.cn" } }, [
              _c("img", {
                staticClass: "logo-1",
                attrs: { src: "/images/gzzx/logo.png", alt: "" }
              }),
              _c("img", { attrs: { src: "/images/login_slogan.png", alt: "" } })
            ])
          ]),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form",
              attrs: {
                model: _vm.formData,
                size: "small",
                "label-position": "right",
                rules: _vm.rules
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "30px" },
                  attrs: { prop: "username" }
                },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        "auto-complete": "off",
                        placeholder: "请输入手机号/邮箱"
                      },
                      model: {
                        value: _vm.formData.username,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "username", $$v)
                        },
                        expression: "formData.username"
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "el-input__icon el-icon-error",
                        attrs: { slot: "suffix" },
                        on: {
                          click: function($event) {
                            _vm.formData.username = ""
                          }
                        },
                        slot: "suffix"
                      })
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "30px" },
                  attrs: { prop: "password" }
                },
                [
                  _c(
                    "el-input",
                    {
                      ref: "passwordInput",
                      attrs: {
                        type: _vm.viewPassword,
                        "auto-complete": "off",
                        placeholder: "请输入密码"
                      },
                      model: {
                        value: _vm.formData.password,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "password", $$v)
                        },
                        expression: "formData.password"
                      }
                    },
                    [
                      _c("template", { slot: "suffix" }, [
                        _vm.viewPassword === "password"
                          ? _c("i", {
                              staticClass: "eyes-close",
                              on: {
                                click: function($event) {
                                  _vm.viewPassword = "text"
                                }
                              }
                            })
                          : _vm._e(),
                        _vm.viewPassword === "text"
                          ? _c("i", {
                              staticClass: "eyes-open",
                              on: {
                                click: function($event) {
                                  _vm.viewPassword = "password"
                                }
                              }
                            })
                          : _vm._e()
                      ])
                    ],
                    2
                  )
                ],
                1
              ),
              _vm.imgAuth.show
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "imgAuth" } },
                      [
                        _c(
                          "el-input",
                          {
                            ref: "imgAuthInput",
                            attrs: {
                              "auto-complete": "off",
                              placeholder: "验证码"
                            },
                            model: {
                              value: _vm.formData.imgAuth,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "imgAuth", $$v)
                              },
                              expression: "formData.imgAuth"
                            }
                          },
                          [
                            _c("template", { slot: "append" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "img-code",
                                  on: { click: _vm.getImgAuth }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        "data:image/jpeg;base64," +
                                        _vm.imgAuth.imgPath
                                    }
                                  })
                                ]
                              )
                            ])
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-submit",
                      staticStyle: { width: "100%", "font-size": "14px" },
                      attrs: { type: "primary", "native-type": "submit" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.submit.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("登录\n        ")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-row",
                    { staticClass: "text-right" },
                    [
                      _c(
                        "nuxt-link",
                        {
                          staticClass: "link-btn",
                          attrs: {
                            to: {
                              path: "/account/forgetPwd",
                              query: { tag: "mobile" }
                            },
                            target: _vm.isIframe ? "_self" : "_blank"
                          }
                        },
                        [_vm._v("忘记密码？\n          ")]
                      ),
                      _c(
                        "nuxt-link",
                        {
                          staticClass: "link-btn",
                          attrs: {
                            to: {
                              path: "/account/register-gzzx",
                              query: { si: "262C83178084DF375AF1A3D6DC3A2E4A" }
                            }
                          }
                        },
                        [_vm._v("新用户注册")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9d123bde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d123bde","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/login-gzzx/index.vue
// module id = gjjU
// module chunks = 154